import { Link } from 'react-router-dom';
import { useForgotPassword } from '../../../hooks';
import { Button } from '../../ui';
import { getLinkWithParams } from '../../../utils';

export function ForgotPassword() {
   const { submitForgotPassword, isLoading, userForgotPasswordForm, setIsLoginModalOpen } = useForgotPassword();

   return (
      <div className="box bg-gray">
         <form
            onSubmit={userForgotPasswordForm.handleSubmit(submitForgotPassword)}
            className="signup-form flex flex-col gap-3">
            <div className="flex flex-col gap-3">
               <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                     type="email"
                     id="email"
                     {...userForgotPasswordForm.register('email')}
                     className={userForgotPasswordForm.formState.errors.email ? 'error-input' : ''}
                  />
                  {userForgotPasswordForm.formState.errors.email && <p className="error-message">{userForgotPasswordForm.formState.errors.email.message as string}</p>}
               </div>

               <div className="flex flex-col gap-2">
                  <Button
                     title="Request Password Reset"
                     type="white-big"
                     className="submit-button"
                     disabled={!userForgotPasswordForm.formState.isValid}
                     loading={isLoading}
                  />
                  <div className="flex justify-center">
                     <p>
                        <Link
                           className="underline"
                           onClick={(e) => {
                              e.stopPropagation();
                              setIsLoginModalOpen(true);
                           }}
                           to={getLinkWithParams('/')}>
                           Login
                        </Link>
                     </p>
                  </div>
               </div>
            </div>
         </form>
      </div>
   );
}
